import React from 'react'
import {ConversationMessage} from "../../../types/Conversation";

// Types ----

type UserMessageProps = {
  message: ConversationMessage
}

// Component ----

function UserMessage({message}: UserMessageProps) {
  return (
    <div className='flex'>
      <div className='rounded-xl bg-brand text-white px-4 py-3 max-w-[70%] ml-auto'>{message.content}</div>
    </div>
  );
}

export {UserMessage};